import yup from '@/infra/YupDecorator';

export const CITIES_ID_WITH_360_POWER = [
  '61a7c93169f60dcbd66aa7cb', // Ribeira do Pombal
];

export const fetchPlacesFormSchema = yup.object({
  name: yup
    .string()
    .when([], (schema, name) =>
      name.value ? schema.min(2) : schema.optional(),
    ),
  city: yup.string().optional(),
  deliveryType: yup.string().optional(),
  establishmentId: yup.string().optional().objectId(),
});
